<template>
  <div v-if="minorAmount">
    <div class="heidi_messaging">
      <div
          id="heidipay-container"
          data-heidipay="true"
          :data-heidipay-minorAmount="minorAmount"
          data-heidipay-allowedterms="20"
          data-heidipay-currencySymbol="EUR"
          data-heidipay-lang="it"
          data-heidipay-type="PRODUCT_DESCRIPTION_HEYLIGHT_FINANCING_IT"
          data-heidipay-apiKey="e2b3375474d132828d4657152eb23480f3805ede"
          data-heidipay-cadence="MONTHLY"
          data-heidipay-thousandsSeparator="."
          data-heidipay-decimalSeparator=","
          data-heidipay-symbolOnLeft="false"
          data-heidipay-spaceBetweenAmountAndSymbol="true"
          data-heidipay-pricing-structure-code="PC6"
          data-heidipay-decimalDigits="2" >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    minorAmount: {
      type: Number,
      required: true
    },
  },
  mounted() {
    const script = document.createElement('script');
    script.src = "https://upstream.heidipay.com/sdk/heidi-upstream-lib.js";
    script.async = true;
    document.head.appendChild(script);
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/widgets/WidgetPagoLight.vue